import WarningSVG from "@design-system/ui-icons/vanilla/Warning"
import { createIcon } from "../createIcon"

export const WarningIcon = createIcon(WarningSVG)
